import api from "api/api";

export const getJobCategoryListQuery = async () =>
  await api.get("/settings/job_categories");

export const getJobCategoryByIdQuery = async (id) =>
  await api.get(`/settings/job_categories/${id}`);

export const createJobCategoryQuery = async (data) =>
  await api.post("/settings/job_categories", data);

export const updateJobCategoryByIdQuery = async (id, data) =>
  await api.put(`/settings/job_categories/${id}`, data);

export const deleteJobCategoryByIdQuery = async (id) =>
  await api.delete(`/settings/job_categories/${id}`);
